import React, { useState, useCallback } from 'react';
import {
  Box, Typography, Paper, Button, IconButton, List, ListItem, ListItemText, Link,
  Stepper, Step, StepLabel
} from '@mui/material';
import { useDropzone } from 'react-dropzone';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import Papa from 'papaparse';
import ValidateDataStep from './ValidateData';

const steps = ['Upload File', 'Validate Data'];

const UploadAndValidate = ({setOpenFileUpload,setRefetch,userId,} ) => {
  const [activeStep, setActiveStep] = useState(0);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [parsedData, setParsedData] = useState([]);

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setUploadedFile(file);

      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          setParsedData(results.data);
          setActiveStep(1); // Move to Validate Step
        },
      });
    }
  }, []);

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    multiple: false,
    accept: { 'text/csv': ['.csv'] },
    noClick: true,
    noKeyboard: true,
  });

  const handleRemoveFile = () => {
    setUploadedFile(null);
    setParsedData([]);
    setActiveStep(0);
  };

  const handleValidationBack = () => {
    setActiveStep(0);
  };

  const handleValidationNext = (validatedData) => {
    console.log('Final Data:', validatedData);
    setActiveStep(2); // Proceed to completion or submission
  };

  return (
    <Box p={4}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={label} completed={index < activeStep}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {activeStep === 0 && (
        <Box display="flex" gap={4} flexWrap="wrap" mt={4}>
          <Paper
            variant="outlined"
            sx={{
              flex: 1,
              minWidth: 360,
              p: 3,
              borderStyle: 'dashed',
              textAlign: 'center',
            }}
          >
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <CloudUploadIcon sx={{ fontSize: 50, color: '#6b46c1' }} />
              <Typography mt={1}>
                Drag and drop files here or click to browse
              </Typography>
              <Button variant="outlined" onClick={open} sx={{ mt: 2 }}>
                Browse Files
              </Button>
            </div>

            {uploadedFile && (
              <Box mt={3} display="flex" alignItems="center" justifyContent="space-between" p={2} bgcolor="success.main" color="white" borderRadius={1}>
                <Typography fontWeight="bold">
                  Uploaded File: {uploadedFile.name}
                </Typography>
                <IconButton onClick={handleRemoveFile} size="small" sx={{ color: 'white' }}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
          </Paper>

          <Box flex={1} minWidth={300}>
            <Typography fontWeight="bold">Upload Instructions:</Typography>
            <List dense>
              <ListItem><ListItemText primary="The file should be in CSV format." /></ListItem>
              <ListItem><ListItemText primary="Ensure all required fields are filled." /></ListItem>
           <ListItem><ListItemText primary="Download the sample template for reference." /></ListItem>
            </List>
            <Paper variant="outlined" sx={{ mt: 2, p: 2, display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2">Need a template?</Typography>
              <Link href="/sample-template.csv" underline="hover">
                Download it here
              </Link>
            </Paper>
        
          </Box>
        </Box>
      )}

      {activeStep === 1 && (
        <ValidateDataStep
          uploadedData={parsedData}
          uploadedFile={uploadedFile}
          onBack={handleValidationBack}
          onNext={handleValidationNext}
          setOpenFileUpload={setOpenFileUpload}
          setRefetch={setRefetch}
          userId={userId}
        />
      )}

 
    </Box>
  );
};

export default UploadAndValidate;
